var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.4 50.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9f6d9;stroke:#4a6a62;stroke-miterlimit:10;stroke-width:0.4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "H") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.2 0.2 17.2 0.2 17.2 17.2 33.2 17.2 33.2 0.2 50.2 0.2 50.2 50.2 33.2 50.2 33.2 34.2 17.2 34.2 17.2 50.2 0.2 50.2 0.2 0.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH);
export default __webpack_public_path__ + "static/media/H.cd9cc040aa72d2280a3fd05a0a7f779f.svg";
export { ForwardRef as ReactComponent };